import { Box, Stack, Alert, AlertTitle } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";

import FormTextField from "../components/common/FormTextField";
import SubmitButton from "../components/buttons/SubmitButton";
import { cleanFormData } from "../helpers/formHelpers";
import { loginUser } from "../redux/actions/userActions";

const LoginForm = () => {
  const dispatch = useDispatch();

  const { loadingUserInfo, errorLoadingUserInfo } = useSelector(
    (state) => state.user,
  );

  const userLoginValidationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  return (
    <Box sx={{ width: "100%" }}>
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={userLoginValidationSchema}
        onSubmit={(values) => {
          dispatch(loginUser(cleanFormData(values)));
        }}
      >
        {() => (
          <Form>
            <Stack spacing={2}>
              {errorLoadingUserInfo && (
                <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
                  <AlertTitle>Login Failed</AlertTitle>
                  {errorLoadingUserInfo}
                </Alert>
              )}

              {/* --- EMAIL INPUT --- */}
              <FormTextField
                name="email"
                label="Email Address"
                type="email"
                placeholder="admin@example.com"
                startIcon={<EmailOutlinedIcon color="action" />}
              />

              {/* --- PASSWORD INPUT --- */}
              <FormTextField
                name="password"
                label="Password"
                placeholder="Enter password"
                type="password"
                startIcon={<LockOutlinedIcon color="action" />}
              />

              <SubmitButton
                loading={loadingUserInfo}
                title="Login"
                loadingText="Authenticating..."
                endIcon={<LoginOutlinedIcon />}
                sx={{ mt: 1 }}
              />
            </Stack>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default LoginForm;
